import { call, put } from 'redux-saga/effects';
import { BACKEND_URL } from '../../../configs';
import { rejectActionPromise } from '../../../utils/rejectActionPromise';
import { resolveActionPromise } from '../../../utils/resolveActionPromise';
import { deleteUserFailed, deleteUserSuccessful } from '../actions';
import { MODULE_BACK_PATH } from '../constants';
import makeRequest from '../../../utils/makeRequest';
import { OK } from '../../../configs/serverStatusCodes';
import processError from '../../../utils/processError';

export default function* deleteUser(action) {
  try {
    const { payload } = action;
    const url = `${BACKEND_URL}/${MODULE_BACK_PATH}/${payload}`;
    const pool = {};
    const dataResponse = yield makeRequest(url, pool, action, 'DELETE', true);
    if (dataResponse.status === OK) {
      yield put(deleteUserSuccessful([]));
      yield call(resolveActionPromise(action));
    } else {
      yield put(deleteUserFailed([]));
      yield call(rejectActionPromise(action));
    }
  } catch (e) {
    yield put(deleteUserFailed([]));
    yield processError(e);
  }
}
